import { FC, ReactNode } from 'react';
import { Link as MuiLink } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import { HarborTheme } from '@/themes/types';

import type { LinkProps as MuiLinkProps } from '@mui/material';
import type { LinkProps as RouterLinkProps } from 'react-router-dom';

type LinkProps = MuiLinkProps &
  RouterLinkProps & {
    children?: ReactNode;
  };

const Link: FC<LinkProps> = (props) => {
  const { children, sx, to, ...rest } = props;

  return (
    <MuiLink to={to} component={RouterLink} sx={{ ...styles, ...sx }} {...rest}>
      {children}
    </MuiLink>
  );
};

const styles = {
  color: 'info.main',
  fontWeight: (theme: HarborTheme) => theme.typography.fontWeightMedium,
  '&:visited': {
    color: 'info.dark',
  },
};

export { Link };
